<app-header [identifier]="identifier" [theme]="theme"></app-header>
<div class="container">
  <div class="row jobClosed">
    <div class="col-12 py-4">
      <p class="text-danger">The status of this open job has just changed to inactive.</p>
      <p class="mb-0">New job applications (and/or in-process applications) are no longer being accepted.
      This status may change at any time, so you are encouraged to periodically review the open jobs list. We regret any inconvenience this may have caused. Click <a [routerLink]="'/' + identifier">here</a> to see a list of our current open positions.</p>
    </div>
  </div>
  <app-footer [theme]="theme"></app-footer>
</div>